import { Navigation } from "./navigation";
import { Contact } from "./contact";
import JsonData from "../data/data.json";
import { useState, useEffect } from "react";

export const Medicos = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <>
      <Navigation />

      <div id="medicos" className="py-5 bg-light">
        <div className="container">

          <h2 className="text-center mb-4">Corpo Clínico</h2>

          <div className="row justify-content-center g-4">

            {/* Médico 1 */}
            <div className="col-12 col-md-6 col-lg-4 d-flex">
              <div className="card shadow-sm border-0 w-100 text-center p-3">

                <h5 className="mb-3">Dr. Ricardo Corrêa Barbuti</h5>

                <div className="medico-img-wrapper mb-3">
                  <img
                    src="/img/mediric.jpg"
                    alt="Dr. Ricardo Corrêa Barbuti"
                    className="img-fluid rounded"
                  />
                </div>

                <a href="/ricardo-barbuti" className="btn btn-outline-primary">
                  Qualificações
                </a>

              </div>
            </div>

            {/* Médico 2 */}
            <div className="col-12 col-md-6 col-lg-4 d-flex">
              <div className="card shadow-sm border-0 w-100 text-center p-3">

                <h5 className="mb-3">Dra. Helena Atroch Machado</h5>

                <div className="medico-img-wrapper mb-3">
                  <img
                    src="/img/medihel.jpg"
                    alt="Dra. Helena Atroch"
                    className="img-fluid rounded"
                  />
                </div>

                <a href="/helena-atroch" className="btn btn-outline-primary">
                  Qualificações
                </a>

              </div>
            </div>

            {/* Médico 3 (futuro) */}
            {/*
      <div className="col-12 col-md-6 col-lg-4 d-flex">
        <div className="card shadow-sm border-0 w-100 text-center p-3">

          <h5 className="mb-3">Dr(a). Futuro Médico</h5>

          <div className="medico-img-wrapper mb-3">
            <img
              src="/img/medico3.jpg"
              alt="Futuro Médico"
              className="img-fluid rounded"
            />
          </div>

          <a href="/qualificacao-medico3" className="btn btn-outline-primary">
            Qualificações
          </a>

        </div>
      </div>
      */}

          </div>
        </div>
      </div>

      <Contact data={landingPageData.Contact} />
    </>
  );
};